import { Sun, Moon, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/useTheme";
import { useHaptics } from "@/hooks/useHaptics";
import { cn } from "@/lib/utils";
export function ThemeToggle() {
  const {
    theme,
    setTheme
  } = useTheme();
  const {
    light
  } = useHaptics();
  const cycleTheme = () => {
    light();
    const themes = ["light", "dark", "dark-premium"] as const;
    const currentIndex = themes.indexOf(theme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setTheme(themes[nextIndex]);
  };
  const getIcon = () => {
    switch (theme) {
      case "light":
        return <Sun className="h-5 w-5" />;
      case "dark":
        return <Moon className="h-5 w-5" />;
      case "dark-premium":
        return <Sparkles className="h-5 w-5" />;
      default:
        return <Sun className="h-5 w-5" />;
    }
  };
  const getLabel = () => {
    switch (theme) {
      case "light":
        return "Claro";
      case "dark":
        return "Escuro";
      case "dark-premium":
        return "Premium";
      default:
        return "Tema";
    }
  };
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      className="w-11 h-11 transition-all hover:scale-105 active:scale-95"
      aria-label={`Alternar tema: ${getLabel()}`}
    >
      {getIcon()}
    </Button>
  );
}